import "geocomplete"

const apikey = gon.google_places_api_key
const placesUri = `https://maps.googleapis.com/maps/api/js?key=${apikey}&libraries=places&language=${gon.locale}`

const withGooglePlaces = function (func) {
  if (window.google?.maps?.places) {
    func()
  } else {
    $.getScript(placesUri, func)
  }
}

const componentForm = {
  street_number:  'short_name',
  route:          'long_name',
  locality:       'long_name',
  administrative_area_level_1: 'short_name',
  country:        'long_name',
  postal_code:    'short_name'
}

const googleGeocomplete = function(input, selector = ".address", options = {}) {
  const elem = this.root.find(`:input${selector}`)
  input.geocomplete(options)
    .bind("geocode:result", (event, result) => {
      console.log(result)
      const formInputs = result.address_components
        .map((obj) => [obj.types[0], obj[componentForm[obj.types[0]]]])
        .reduce((obj, [name, value]) => (obj[name] = value, obj), {})
      input.trigger("geocomplete:result", formInputs, event)
    })
    .bind("geocode:error", (error) => {
      console.error(error)
    })
}


export { withGooglePlaces, googleGeocomplete, placesUri, componentForm }
